export default function () {
	const groupHovers = document.querySelectorAll('.group-hover');
  const hamburger = document.querySelector('.hamburger');
	const inertEls = document.querySelectorAll('#site-main, #site-footer, .contact-button, #skip-to-content, .nav-wrapper:not(.overlay)');
	const openLabel = hamburger?.dataset.openLabel;
	const closeLabel = hamburger?.dataset.closeLabel;

  // group hover
	groupHovers.forEach((group) => {
		const links = group.querySelectorAll('.group-item');

		links.forEach((link) => {

			link.addEventListener('mouseover', function () {
				links.forEach((l) => {
					const nextElementSibling = l.nextElementSibling;

					if (link != l) {
						l.classList.add('opacity-25');
					}

					if (nextElementSibling?.tagName.toLowerCase() === 'span' && nextElementSibling.hasAttribute('data-menu-tiret')) {
						nextElementSibling.classList.add('opacity-25');
					}
				});
			});

			link.addEventListener('mouseout', function () {
				links.forEach((l) => {
					const nextElementSibling = l.nextElementSibling;

					if (link != l) {
						l.classList.remove('opacity-25');
					}

					if (nextElementSibling?.tagName.toLowerCase() === 'span' && nextElementSibling.hasAttribute('data-menu-tiret')) {
						nextElementSibling.classList.remove('opacity-25');
					}
				});
			});

		});
	});

  // mobile menu
	hamburger?.addEventListener('click', function () {
		if (document.body.classList.contains('overlay-is-active')) {
			document.body.classList.add('closing');
			hamburger.setAttribute('aria-label', openLabel);
			inertEls.forEach((el) => {
				el.removeAttribute('inert');
			});
		} else {
			document.body.classList.add('overlay-is-active', 'opening');
			hamburger.setAttribute('aria-label', closeLabel);
			inertEls.forEach((el) => {
				el.setAttribute('inert', '');
			});
		}
	});

	let iteration = 0;
	document.addEventListener('animationstart', (event) => {
		if (event.animationName === 'menu-disappear') {
			iteration++;
		}
		if (event.animationName === 'menu-appear') {
			iteration++;
		}
	});

	document.addEventListener('animationend', (event) => {
		if (event.animationName === 'menu-disappear' && iteration >= 5) {
			setTimeout(() => {
				document.body.classList.remove('overlay-is-active', 'closing');
			}, 300);
			iteration = 0;
		}
		if (event.animationName === 'menu-appear' && iteration >= 5) {
			setTimeout(() => {
				document.body.classList.remove('opening');
			}, 300);
			iteration = 0;
		}
	});
}
